
'use client';

import React from 'react';
import Link from 'next/link';
import { BookCopy, PanelLeft, Shield } from 'lucide-react';
import { UserNav } from './user-nav';
import { useAuth } from '@/context/auth-provider';
import { useActiveProject } from '@/context/active-project-context';
import { Button } from '../ui/button';
import { useSidebar } from '../ui/sidebar';
import { useIsMobile } from '@/hooks/use-mobile';
import { usePathname } from 'next/navigation';
import { ChatPanelTrigger } from '@/domains/chat/components';

export function GlobalHeader() {
  const { isAdmin } = useAuth();
  const { activeProject } = useActiveProject();
  const { toggleSidebar } = useSidebar();
  const isMobile = useIsMobile();
  const pathname = usePathname();

  // Only show the mobile menu button on project pages
  const isProjectPage = pathname.startsWith('/projects/');

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center">
        <div className="mr-4 hidden md:flex items-center">
          <Link href="/" className="flex items-center space-x-2">
            <BookCopy className="h-6 w-6" />
            <span className="font-bold">
              StoryStudio v0.7.2.7
            </span>
          </Link>
          {activeProject && (
            <>
              <span className="mx-2 text-muted-foreground">/</span>
              <span className="text-sm text-muted-foreground truncate max-w-[200px]">
                {activeProject.title}
              </span>
            </>
          )}
        </div>
        
        {isMobile && isProjectPage && (
            <Button variant="ghost" size="icon" onClick={toggleSidebar}>
                <PanelLeft className="h-5 w-5" />
                <span className="sr-only">Toggle Sidebar</span>
            </Button>
        )}
        
        <div className="flex flex-1 items-center justify-end space-x-2">
          <ChatPanelTrigger />
          {isAdmin && (
            <Link href="/admin">
              <Button variant={pathname.startsWith('/admin') ? 'secondary' : 'ghost'} size="sm" className="gap-1.5">
                <Shield className="h-4 w-4" />
                <span className="hidden sm:inline">Admin</span>
              </Button>
            </Link>
          )}
          <UserNav />
        </div>
      </div>
    </header>
  );
}
